module.exports = __webpack_public_path__ + "img/info-info_org.png";